module.exports = __webpack_public_path__ + "assets/media/evening.e9d66469.mp3";